import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner,
  ExportToExcel
} from '../../config/react'
import DataTable from 'react-data-table-component'

const CatalogPriceRule = () => {
  const [CatalogPriceRuleList, setCatalogPriceRuleList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [SearchTerm, setSearchTerm] = useState('')
  const columns = [
    {
      name: 'Rule Name',
      sortable: true,
      sortField: 'rule_name',
      selector: (row) => row.rule_name,
      wrap: true
    },
    {
      name: 'Start Date',
      selector: (row) => <DateFormat value={row.start_date}></DateFormat>
    },
    {
      name: 'End Date',
      selector: (row) => <DateFormat value={row.end_date}></DateFormat>
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/marketing/catalog-price-rule/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteCatalogPriceRule(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.CatalogPriceRule
    GetCatalogPriceRuleList()
  }, [CustomFilters, SearchTerm])

  const GetCatalogPriceRuleList = () => {
    const catalogPriceRuleData = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // HttpService.postApi(API.GetCouponList, catalogPriceRuleData)
    setLoading(true)
    HttpService.postApi(API.GetCatalogPriceRuleList, catalogPriceRuleData).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];
        setCatalogPriceRuleList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_count)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }
  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        className="form-control col-md-3"
        placeholder="Search"
        title="Search For Rule Name."
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  const DeleteCatalogPriceRule = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteCatalogPriceRule, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetCatalogPriceRuleList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  const handleExportExcel = () => {
    HttpService.postApi(API.GetCatalogPriceRuleExcel).then((response) => {
      if (response.data.result) {
        ExportToExcel(response.data.result[0], 'Catalog-Price-Rule')
      }
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.CatalogPriceRule} </h3>
        <div className="btn-group">
          <Link
            to="/marketing/catalog-price-rule/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Catalog Price Rule{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <button
                className="btn btn-primary float-right m-1"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <div className="table-responsive">
                <DataTable
                  // title="Coupons"
                  columns={columns}
                  data={CatalogPriceRuleList}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  // progressPending={loading}
                  persistTableHead={true}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  paginationDefaultPage={currentPage}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default CatalogPriceRule
